<template>
  <div class="index">
    <NavBar v-if="titleStatus" title="金地物业&白鲸鱼" fixed placeholder />
    <div class="banner" v-show="pageConfig?.data?.headImg?.isDisabled">
      <img
        :src="pageConfig.data?.headImg?.img[0]?.response?.data?.url"
        @click=""
        alt
      />
      <div
        class="rule"
        :style="{
          color:
            'rgba(' + pageConfig.data.headImg?.func[0]?.rule?.ftColor + ')',
          background:
            'rgba(' + pageConfig.data.headImg?.func[0]?.rule?.bgColor + ')',
        }"
        v-if="pageConfig.data.headImg?.func[0]?.rule?.open"
        @click="linkTo('/WelfareRules')"
      >
        规则
      </div>
    </div>

    <div class="main">
      <!-- 导航栏 -->
      <div class="nav" v-if="pageConfig.data.headNav?.isDisabled">
        <div
          :class="[
            'nav-item',
            pageConfig.data.headNav.data.length >= 6 &&
            pageConfig.data.headNav.data.length <= 7
              ? 'six'
              : pageConfig.data.headNav.data.length == 8
              ? 'eight'
              : '',
          ]"
          v-for="(item, index) in pageConfig.data.headNav?.data"
          :key="index"
          @click="linkCheck(item)"
        >
          <div
            v-if="!(index === 6 && pageConfig.data.headNav.data.length === 7)"
          >
            <img
              class="nav-img"
              :src="
                item.icon.length
                  ? item.icon[0].response?.data.url
                  : item.iconDefault
              "
              :alt="item.title"
              srcset
            />
            <div class="nav-text">{{ item.name ? item.name : "暂无填写" }}</div>
          </div>
        </div>
      </div>
      <!-- 预约按钮 -->
      <div class="yuyue" v-if="pageConfig.data.yuyueBtn?.isDisabled">
        <div class="yuyue-h">
          <img
            :src="pageConfig.data?.yuyueBtn?.stepImg[0]?.response?.data?.url"
            alt
          />
        </div>
        <div class="yuyue-c">
          <div class="btn" @click="linkTo('/Yuyue')">
            <!-- <div class="red_bag">
              <div class="wrap">
                <img
                  class="l"
                  src="https://bjyoss.oss-cn-hangzhou.aliyuncs.com/image/C-left.png"
                  alt
                />
                <img
                  class="bag"
                  src="https://bjyoss.oss-cn-hangzhou.aliyuncs.com/image/redbag.png"
                  alt
                />
                <img
                  class="r"
                  src="https://bjyoss.oss-cn-hangzhou.aliyuncs.com/image/C-right.png"
                  alt
                />
              </div>
              <img
                class="grass"
                src="https://bjyoss.oss-cn-hangzhou.aliyuncs.com/image/cao.png"
                alt
              />
            </div>
            <div class="title">预约上门收衣</div>
            <div class="des">
              支持300+城市
              <span>免运费</span>
            </div>
            <div class="go_btn">
              <img
                src="https://bjyoss.oss-cn-hangzhou.aliyuncs.com/image/bjy_template/test/go.png"
                alt
              />
              <img
                class="go_bg"
                src="https://bjyoss.oss-cn-hangzhou.aliyuncs.com/image/bjy_template/test/go_bg.png"
                alt
              />
            </div>-->
            <img
              :src="pageConfig.data?.yuyueBtn?.btnImg[0]?.response?.data?.url"
              alt
            />
          </div>
        </div>
        <div class="yuyue-f">
          <div class="trumpet">
            <img
              src="https://bjyoss.oss-cn-hangzhou.aliyuncs.com/image/bjysf/index/laba.png"
              alt
              srcset
            />
          </div>
          <Swipe
            class="yuyueList"
            :autoplay="3000"
            indicator-color="white"
            :vertical="true"
          >
            <SwipeItem v-for="(item, index) in yuyueList" :key="index">
              <div>
                {{
                  item.truename.length > 6
                    ? item.truename.slice(0, 6) + "..."
                    : item.truename
                }}预约成功 {{ item.created }}
              </div>
            </SwipeItem>
          </Swipe>
        </div>
      </div>
      <!-- 新闻列表-->
      <div class="news">
        <div class="news-t">新闻资讯</div>
        <div class="news-list">
          <div
            class="news-li"
            v-for="(item, index) in news"
            :key="index"
            @click="linkTo('/information', { itemid: item.itemid })"
          >
            <div class="l">
              <img :src="item.img" />
            </div>
            <div class="r">
              <div class="title">{{ item.title }}</div>
              <div class="content">{{ item.content }}</div>
              <div class="date" v-if="item.date">{{ item.date }}</div>
            </div>
          </div>
        </div>
      </div>
      <!-- 回收去向 -->
      <div
        class="recycle"
        v-if="pageConfig.data.way?.isDisabled"
        @click="linkTo('/way')"
      >
        <div class="titleWrap">
          <div class="title">
            {{
              pageConfig.data.way.modelName
                ? pageConfig.data.way.modelName
                : "回收处理与去向"
            }}
          </div>
          <div class="more">
            查看详情
            <span class="iconfont icon-youbian"></span>
          </div>
        </div>
        <div class="items">
          <div
            class="item"
            :style="{ background: 'url(' + item.img + ')' }"
            v-for="(item, index) in recycle"
            :key="index"
          >
            <div class="title">{{ item.title }}</div>
            <div class="idx">{{ index + 1 }}</div>
          </div>
        </div>
      </div>
      <!-- 常见问题 -->
      <div class="questions" v-if="pageConfig.data.questions?.isDisabled">
        <div class="title">常见问题</div>
        <Collapse v-model="ques_idx" accordion :border="false">
          <CollapseItem
            class="CollapseItem"
            :title="item.ques ? item.ques : '暂无填写'"
            :name="String(index + 1)"
            v-for="(item, index) in questions"
            :key="index"
            :icon="
              index == 0
                ? 'https://bjyoss.oss-cn-hangzhou.aliyuncs.com/image/bjy_template/test/hot.png'
                : ''
            "
            :border="false"
            >{{ item.answer ? item.answer : "暂无填写" }}</CollapseItem
          >
        </Collapse>
      </div>
      <!-- 回收排行 -->
      <div class="rank" v-if="pageConfig.data.rank?.isDisabled">
        <div class="title">
          {{
            pageConfig.data.rank?.modelName
              ? pageConfig.data.rank.modelName
              : "回收达人排行榜"
          }}
        </div>
        <div class="itemsWrap">
          <div class="items">
            <css-seamless-scroll
              :datas="rankList"
              :step="1000"
              :limitScrollNum="6"
              class="scroll"
            >
              <div class="item" v-for="(item, index) in rankList" :key="index">
                <div class="l">
                  <div class="idx">{{ index + 1 }}</div>
                  <div class="avatar">
                    <img
                      :src="
                        'https://dev.52bjy.com/api/avatar/show.php?username=' +
                        item.username
                      "
                      alt
                      srcset
                    />
                  </div>
                  <div class="nickName">{{ item.truename }}</div>
                </div>
                <div class="r">回收{{ item.weight }}kg</div>
              </div>
            </css-seamless-scroll>
          </div>
        </div>
      </div>
      <!-- 合作 -->
      <div
        class="cooperation"
        v-if="pageConfig.data.cooperationLogo?.isDisabled"
      >
        <div class="wrap">
          <img
            @click=""
            :src="pageConfig.data?.cooperationLogo?.img[0]?.response?.data?.url"
          />
        </div>
      </div>
    </div>

    <FixedBtn :data="service_Btn" v-if="service_Flag" />

    <!-- 底部导航 -->
    <Tabbar index="首页" />
  </div>
</template>

<script>
// @ is an alias to /src
import { defineComponent, ref, reactive, onMounted } from "vue";
import routers from "@/hooks/routers";
import { getQueryObject } from "@/utils";
import { useStore } from "vuex";
import md5 from "md5";

// 组件
import Tabbar from "@/components/Tabbar/Tabbar.vue";
import FixedBtn from "@/components/FixedBtn/FixedBtn.vue";
import { NavBar, Swipe, SwipeItem, Collapse, CollapseItem, Dialog } from "vant";

// api
import { yuyue_list, yuyue_rank } from "@/api/yuyue";
import { getPartner, getPartnerSetting } from "@/api/partner";
import GoBack from "../components/GoBack/GoBack.vue";

export default defineComponent({
  name: "Index",
  setup() {
    // 预约成功列表
    let yuyueList = reactive([]);

    /**
     * @description: 获取预约成功列表
     * @param {*}
     * @return {*}
     */
    async function getYuyueList() {
      let params = {
        appkey: store.state.appkey,
        channel: store.state.channel,
      };
      let resutl = await yuyue_list(params);
      if (resutl.data.isSucess) {
        yuyueList.push(...resutl.data.data);
      }
    }

    let news = reactive([
      {
        title: "尽速8之力，守“沪”平安",
        content:
          "速8人的身影，从晨光初现，到万家灯火，速8人在抗疫一线上日夜奋战，从未停下脚步。",
        date: "2022年4月",
        img: "https://bjyoss.oss-cn-hangzhou.aliyuncs.com/image/active/super8/a1.png",
        itemid: 0,
      },
      {
        title: "春节这站在速8， 就地过年免费住",
        content:
          "回家过年，是每一个中国人心中最幸福的期盼，可以抛开一年的重负、可以卸下生活的压力，尽情享受与家人团聚的温暖和快乐。",
        date: "2022年2月",
        img: "https://bjyoss.oss-cn-hangzhou.aliyuncs.com/image/active/super8/b1.png",
        itemid: 1,
      },
    ]);

    let recycle = reactive([
      {
        title: "环保循环",
        img: "https://bjyoss.oss-cn-hangzhou.aliyuncs.com/image/bjy_template/test/way1.jpg",
      },
      {
        title: "分拣再生",
        img: "https://bjyoss.oss-cn-hangzhou.aliyuncs.com/image/bjy_template/test/way2.jpg",
      },
      {
        title: "转送山区",
        img: "https://bjyoss.oss-cn-hangzhou.aliyuncs.com/image/bjy_template/test/way3.jpg",
      },
      {
        title: "旧衣出口",
        img: "https://bjyoss.oss-cn-hangzhou.aliyuncs.com/image/bjy_template/test/way4.jpg",
      },
    ]);

    let ques_idx = ref("1"); // 当前问题下标

    // 问题列表
    let questions = reactive([]);

    //  回收排行
    let rankList = reactive([]);

    /**
     * @description: 获取预约排行列表
     * @param {*}
     * @return {*}
     */
    async function getRankList() {
      let params = {
        channel: store.state.channel,
        limit: 20,
      };
      let resutl = await yuyue_rank(params);
      // console.log(resutl);
      if (resutl.data.isSucess) {
        if (pageConfig.data.rank.num) {
          //截取后台所配置的显示条数
          rankList.push(...resutl.data.data.slice(0, pageConfig.data.rank.num));
        } else {
          rankList.push(...resutl.data.data);
        }
      }
    }

    // 定位按钮
    let service_Btn = reactive([]);
    let service_Flag = ref(false);

    // 页面配置
    let pageConfig = reactive({ data: {} });
    /**
     * @description: 合作商授权
     * @param {*}
     * @return {*}
     */
    async function getAuth() {
      // 解析query
      let query = getQueryObject();
      // 合作商id
      let partner_id = "";
      // 本地缓存
      let cache = JSON.parse(localStorage.getItem("CONFIG"));

      if (query.itemid) {
        partner_id = query.itemid;
      } else if (cache) {
        partner_id = cache.partnerConfig.basic.itemid;
      } else {
        Dialog.alert({
          message: "查无此合作商",
          theme: "",
          confirmButtonColor: "#101010",
        });
        return;
      }

      let params = {
        partner_id,
      };

      let resutl = await getPartner(params);

      // console.log(resutl);
      if (resutl.status === 200 && resutl.data?.isSucess) {
        store.commit("setPartnerConfig", {
          option: "basic",
          data: resutl.data.data,
        });

        document
          .getElementsByTagName("body")[0]
          .style.setProperty(
            "--themeColor",
            `rgb(${resutl.data.data.theme_color})`
          ); // 设置主题色
        document
          .getElementsByTagName("body")[0]
          .style.setProperty(
            "--themeBgColor",
            `rgb(${resutl.data.data.theme_color},0.1)`
          ); // 设置主题背景色

        document.title = resutl.data.data.title; // 设置页面标题

        store.state.partnerId = resutl.data.data.itemid; // 合作商id
        store.state.appkey = resutl.data.data.appkey; // 合作商appkey
        store.state.channel = resutl.data.data.channel; // 合作商channel
        store.state.secret = resutl.data.data.secret; // secret
        getIndexConfig(); // 获取合作商首页配置
        localStorage.setItem("CONFIG", JSON.stringify(store.state));

        // 第一次进来登录判断
        if (!store.getters.isLogin) {
          if (resutl.data.data.login_type === "1") {
            linkTo("/login");
          } else {
            let browser = navigator.userAgent.toLowerCase();
            let query = getQueryObject();
            if (
              browser.match(/MicroMessenger/i) == "micromessenger" ||
              query.username
            ) {
              setUserInfo();
            } else {
              Dialog.alert({
                message: "暂未谈好静默授权方式",
                theme: "",
                confirmButtonColor: "#101010",
              });
            }
          }
        }
      } else {
        Dialog.alert({
          message: resutl.data.message,
          theme: "",
          confirmButtonColor: "#101010",
        });
      }
    }

    /**
     * @description: 获取合作商首页配置
     * @param {*}
     * @return {*}
     */
    async function getIndexConfig() {
      let sign = md5(
        `action=setting&appkey=${store.state.appkey}&item_key=homePage&partner_id=${store.state.partnerId}${store.state.secret}`
      );

      let params = {
        appkey: store.state.appkey,
        item_key: "homePage",
        partner_id: store.state.partnerId,
        sign,
      };
      let resutl = await getPartnerSetting(params);
      // console.log(resutl);
      if (resutl.status === 200 && resutl.data?.isSucess) {
        resutl.data.data.item_value = JSON.parse(resutl.data.data.item_value);
        pageConfig.data = resutl.data.data.item_value;
        questions.push(...pageConfig.data.questions.data);
        service_Btn.push(...pageConfig.data.suspendButton.data);
        service_Flag.value = pageConfig.data.suspendButton.isDisabled;
        // news.push(...pageConfig.data.news.data);
        getRankList();
      }
    }

    function linkCheck(data) {
      if (data.template) {
        if (data.template === "旧衣服回收") {
          linkTo("/Yuyue");
        } else if (data.template === "地址管理") {
          linkTo("/Addresses");
        } else if (data.template === "上门地区") {
          linkTo("/scope");
        } else if (data.template === "回收与处理") {
          linkTo("/way");
        } else if (data.template === "我的订单") {
          linkTo("/record");
        } else if (data.template === "规则") {
          linkTo("/welfareRules");
        } else if (data.template === "证书") {
          link_zs();
        } else if (data.template === "分享") {
          link_fx();
        } else if (data.template === "客服") {
          linkTo_H5(
            "https://g5gg6x2hoblhg.cschat.antcloud.com.cn/index.htm?tntInstId=7Lo_GpVs&scene=SCE00165722"
          );
        } else if (data.template === "登录/注册") {
          linkTo("/Login");
        } else if (data.template === "全不是" && data.other === "h5") {
          linkTo_H5(data.link);
        } else if (
          data.template === "全不是" &&
          data.other === "支付宝小程序"
        ) {
          let flag =
            /\/pages\/index\/index|\/pages\/yuyue\/yuyue|\/pages\/qiandao\/qiandao|\/pages\/jilu\/jilu|\/pages\/my\/my/.test(
              data.link
            );
          flag
            ? my.switchTab({ url: data.link })
            : my.navigateTo({ url: data.link });
        } else if (data.template === "全不是" && data.other === "微信小程序") {
          let flag =
            /\/pages\/index\/index|\/pages\/yuyue\/yuyue|\/pages\/qiandao\/qiandao|\/pages\/quanzi\/quanzi|\/pages\/jilu\/jilu|\/pages\/my\/my/.test(
              data.link
            );
          flag
            ? wx.miniProgram.switchTab({ url: data.link })
            : wx.miniProgram.navigateTo({ url: data.link });
        } else if (data.template === "全不是" && data.other === "自定义") {
          Dialog.alert({
            message: "暂无设置自定义跳转",
            theme: "",
            confirmButtonColor: "#101010",
          });
        }
      } else {
        Dialog.alert({
          message: "暂无设置跳转",
          theme: "",
          confirmButtonColor: "#101010",
        });
      }
    }

    /**
     * @description: 证书跳转
     * @param {*}
     * @return {*}
     */
    function link_zs() {
      let data = store.state.partnerConfig?.basic;
      if (data.certificate === "0") {
        linkTo("/Certificate");
      } else {
        Dialog.alert({
          message: "暂无开启证书跳转",
          theme: "",
          confirmButtonColor: "#101010",
        });
      }
    }

    /**
     * @description: 分享跳转
     * @param {*}
     * @return {*}
     */
    function link_fx() {
      let data = store.state.partnerConfig?.basic;
      if (data.share_type) {
        if (data.share_type === "生成分享海报") {
          linkTo("/Poster");
        } else if (data.share_type === "合作方自带集成sdk") {
          if (data.share_content) {
            linkTo_H5(data.share_content);
          } else {
            Dialog.alert({
              message: "暂无设置sdk跳转地址",
              theme: "",
              confirmButtonColor: "#101010",
            });
          }
        }
      } else {
        Dialog.alert({
          message: "暂无开启分享跳转",
          theme: "",
          confirmButtonColor: "#101010",
        });
      }
    }

    /**
     * @description: 静默授权
     * @param {*}
     * @return {*}
     */
    function setUserInfo() {
      let query = getQueryObject();

      // 静默授权，参数携带用户名
      if (query.username) {
        let userData = {
          truename: query.username,
          username: query.username,
          token: md5(query.username + "#$@JYF0+)@!"),
        };
        store.commit("setUserInfo", userData);
      } else {
        Dialog.alert({
          message: "静默授权失败",
          theme: "",
          confirmButtonColor: "#101010",
        });
      }
    }

    //路由跳转
    const { linkTo, linkTo_H5 } = routers();
    const store = useStore();
    const titleStatus = store.state.titleStatus;

    onMounted(() => {
      getAuth();
      getYuyueList();
    });

    return {
      titleStatus,
      yuyueList,
      news,
      recycle,
      ques_idx,
      questions,
      rankList,
      service_Btn,
      service_Flag,
      linkTo,
      linkTo_H5,
      linkCheck,
      pageConfig,
    };
  },
  components: {
    Tabbar,
    FixedBtn,
    NavBar,
    Swipe,
    SwipeItem,
    Collapse,
    CollapseItem,
    GoBack,
  },
});
</script>
<style lang="scss" scoped>
:deep(.van-icon__image) {
  width: unset;
  height: 0.24rem;
}
.banner {
  position: relative;
  img {
    width: 100%;
    min-height: 100px;
    background: var(--themeColor);
  }
  .rule {
    position: absolute;
    right: 0;
    bottom: 0.15rem;
    font-size: 12px;
    color: #fff;
    border-radius: 0.3rem 0 0 0.3rem;
    background: rgba(0, 0, 0, 0.5);
    padding: 0.02rem 0.1rem;
  }
}

.main {
  padding: 0.1rem 0.1rem 0.86rem;
  background: var(--themeColor);
  min-height: 100vh;
  box-sizing: border-box;
  // 导航栏
  .nav {
    padding: 0.15rem 0 0;
    background: #fff;
    border-radius: 0.1rem;
    font-size: 0.14rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-flow: wrap;
    .nav-item {
      flex: 1;
      text-align: center;
      overflow: hidden;
      &.six {
        width: 33%;
        flex: unset;
      }
      &.eight {
        width: 25%;
        flex: unset;
      }
      img {
        width: 0.45rem;
        height: auto;
        display: inline-block;
        margin: 0 0 0.05rem;
      }
      .nav-text {
        margin: 0 0 0.15rem 0;
      }
    }
  }
  // 预约按钮
  .yuyue {
    padding: 0.1rem 0 0.15rem;
    margin: 0.1rem 0;
    background: #fff;
    border-radius: 0.1rem;
    font-size: 0.12rem;
    .yuyue-h {
      padding: 0 0.1rem;
      img {
        width: 100%;
        height: auto;
      }
    }
    .yuyue-c {
      .btn {
        width: calc(100% - 0.4rem);
        margin: 0.15rem auto;
        // background: linear-gradient(-82.755deg, #ff8d4e 0%, #ff404f 100%);
        // box-shadow: 0px 0px 5px #eb4956;
        border-radius: 0.3rem;
        text-align: center;
        color: #fff;
        position: relative;
        img {
          width: 100%;
          height: auto;
        }
        // .red_bag {
        //   position: absolute;
        //   top: 0;
        //   left: 0;
        //   height: 100%;
        //   width: 0.9rem;
        //   .wrap {
        //     animation: fly 3s linear infinite;
        //     .l {
        //       width: 0.25rem;
        //       height: auto;
        //       position: absolute;
        //       left: 3%;
        //       top: 25%;
        //       z-index: 1;
        //       transform-origin: center right;
        //       animation: Left 3s linear infinite;
        //     }
        //     .bag {
        //       width: 50%;
        //       height: auto;
        //       position: absolute;
        //       left: 25%;
        //       top: -0.1rem;
        //       z-index: 2;
        //       // ios z-index 层级兼容
        //       transform: translateZ(100px);
        //     }
        //     .r {
        //       width: 0.25rem;
        //       height: auto;
        //       position: absolute;
        //       right: 3%;
        //       top: 25%;
        //       z-index: 1;
        //       transform-origin: center left;
        //       animation: Right 3s linear infinite;
        //     }
        //   }
        //   .grass {
        //     width: 100%;
        //     position: absolute;
        //     left: 0;
        //     bottom: 0;
        //     z-index: 0;
        //   }
        // }
        // .title {
        //   margin: 0 0 0.05rem;
        //   font-size: 16px;
        //   font-weight: bold;
        // }
        // .go_btn {
        //   position: absolute;
        //   top: 0.05rem;
        //   right: 0.075rem;
        //   img {
        //     width: 0.45rem;
        //     height: auto;
        //   }
        //   .go_bg {
        //     position: absolute;
        //     left: 0;
        //     top: 0;
        //     transform: scale(1.3);
        //     animation: rotate 3s infinite linear;
        //   }
        // }
      }
    }
    .yuyue-f {
      position: relative;
      text-align: center;
      line-height: 0.24rem;
      .trumpet {
        position: absolute;
        width: 0.24rem;
        top: 0;
        left: 0.45rem;
        img {
          width: 100%;
          height: auto;
        }
      }
      .yuyueList {
        overflow: hidden;
        height: 0.2rem;
      }
    }
  }
  // 新闻列表
  .news {
    background: #fff;
    padding: 0.15rem 0.15rem 0 0.15rem;
    border-radius: 0.1rem;
    .news-t {
      text-align: center;
      color: #111111;
      margin: 0 0 0.05rem 0;
      font-weight: bold;
    }
    .news-li {
      display: flex;
      justify-content: space-between;
      padding: 0.1rem 0;
      border-bottom: 1px solid #f2f2f2;
      .l {
        width: 1.3rem;
        img {
          border-radius: 0.05rem;
          width: 100%;
          // height: auto;
          height: 0.9rem;
        }
      }
      .r {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        width: calc(100% - 1.4rem);
        margin: 0 0 0 0.1rem;
        font-size: 0.12rem;
        .title {
          font-size: 0.14rem;
          margin: 0 0 5px 0;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .content {
          line-height: 0.2rem;
          overflow: hidden;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
        }
        .date {
          color: #999;
          text-align: right;
        }
      }
    }
  }
  // 回收去向
  .recycle {
    background: #fff;
    padding: 0.15rem 0.15rem 0 0.15rem;
    border-radius: 0.1rem;
    margin: 0.1rem 0;
    .titleWrap {
      position: relative;
      margin: 0 0 0.1rem;
      .title {
        text-align: center;
        padding: 0 0 0.05rem 0;
        font-weight: bold;
      }
      .more {
        position: absolute;
        font-size: 0.12rem;
        color: #666;
        top: 0.025rem;
        right: 0;
        .iconfont {
          color: #666;
          font-size: 0.12rem;
        }
      }
    }
    .items {
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: wrap;
      .item {
        width: calc(50% - 0.05rem);
        border-radius: 0.05rem;
        margin: 0 0 0.1rem;
        position: relative;
        background: gray;
        border-radius: 0.05rem;
        overflow: hidden;
        text-align: center;
        line-height: 0.8rem;
        opacity: 0.7;
        .title {
          font-weight: bold;
          font-size: 0.2rem;
        }
        .idx {
          position: absolute;
          top: 0;
          left: 0;
          border-radius: 0 0 0.05rem;
          color: #c10000;
          font-size: 0.12rem;
          width: 0.2rem;
          text-align: center;
          line-height: 0.15rem;
          background: #fff;
        }
      }
    }
  }
  // 常见问题
  .questions {
    background: #fff;
    padding: 0 0 0.15rem 0;
    border-radius: 0.1rem;
    .title {
      text-align: center;
      padding: 0.15rem 0 0;
      font-weight: bold;
    }
  }
  // 回收排行
  .rank {
    background: #fff;
    padding: 0.15rem 0.15rem 0 0.15rem;
    border-radius: 0.1rem;
    margin: 0.1rem 0 0 0;
    .title {
      text-align: center;
      margin: 0 0 0.15rem;
      font-weight: bold;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .itemsWrap {
      overflow: hidden;
      height: 4rem;
      .item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 0.14rem;
        border-bottom: 1px solid #f1f1f1;
        padding: 0.1rem 0;
        .l {
          display: flex;
          justify-content: space-between;
          align-items: center;
          .avatar {
            width: 0.5rem;
            height: 0.5rem;
            border-radius: 100%;
            overflow: hidden;
            margin: 0 0.1rem;
            img {
              width: 100%;
              height: auto;
            }
          }
        }
        &:last-child {
          border: none;
        }
      }
    }
  }
  .cooperation {
    padding: 0.15rem 0 0;
    .wrap {
      text-align: center;
      img {
        width: 100%;
        height: auto;
        display: inline-block;
      }
    }
  }

  // 动画区
  @keyframes rotate {
    0% {
      transform: scale(1.3) rotate(0deg);
    }
    100% {
      transform: scale(1.3) rotate(360deg);
    }
  }
  // 红包飞舞动画
  @keyframes fly {
    0% {
      transform: translate(0, 0);
    }

    50% {
      transform: translate(0, 10px);
    }

    100% {
      transform: translate(0, 0);
    }
  }
  @keyframes Left {
    0% {
      transform: rotateY(0);
    }

    25% {
      transform: rotateY(55deg);
    }

    35% {
      transform: rotateY(20deg);
    }

    50% {
      transform: rotateY(55deg);
    }

    65% {
      transform: rotateY(15deg);
    }

    100% {
      transform: rotateY(0);
    }
  }
  @keyframes Right {
    0% {
      transform: rotateY(0deg);
    }

    25% {
      transform: rotateY(55deg);
    }

    35% {
      transform: rotateY(20deg);
    }

    50% {
      transform: rotateY(55deg);
    }

    65% {
      transform: rotateY(15deg);
    }

    100% {
      transform: rotateY(0deg);
    }
  }
}
</style>
